import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcReview(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.5 12a7.5 7.5 0 1 0-3.835 6.541l.085-.042a.95.95 0 0 1 .565-.062l.095.024 2.96.907-.908-2.959a.95.95 0 0 1 .08-.745l.216-.414A7.45 7.45 0 0 0 19.5 12M14 13.25a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5zm2-3.5a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5zM21 12a8.95 8.95 0 0 1-1.037 4.19l1.143 3.73a.95.95 0 0 1-1.186 1.186l-3.73-1.144A8.95 8.95 0 0 1 12 21a9 9 0 1 1 9-9"
  }));
}
var IcReview = createNolIcon(/*#__PURE__*/forwardRef(SvgIcReview));

export { IcReview as I };
